export class Producer {
    id: number = 1;
    name: string;
}


// WEBPACK FOOTER //
// ./src/model/producer.ts